import { populate } from "populate";

const raw = {
  handleResize: true,
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "e58b0486-55a4-4e04-80ce-675e2d6572e1",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "65fa5e94-81e2-4748-abd3-e3300e7155ff",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cards_indicator",
      parent: "e58b0486-55a4-4e04-80ce-675e2d6572e1",
      data: ""
    },
    {
      id: "fb72d5eb-70df-443f-b379-2bff201eb001",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 25,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "+",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 38,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#220c7d",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "e58b0486-55a4-4e04-80ce-675e2d6572e1",
      data: ""
    },
    {
      id: "44383857-352a-4673-9b3d-6370b3cbd2c8",
      type: "Text",
      name: "amountText",
      nameSpace: "",
      className: "",
      x: 51,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "99",
      localize: false,
      maxWidth: 80,
      maxHeight: 43,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#220c7d",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "e58b0486-55a4-4e04-80ce-675e2d6572e1",
      data: ""
    }
  ]
} as const;

export class StackCardsLabelLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  amountText: GameObject<PIXI.Text>;

  constructor() {
    populate(this, raw);
  }
}
